import { dateFnsLocalizer } from 'react-big-calendar';

import {
  startOfWeek as dateFnsStartOfWeek,
  format as dateFnsFormat,
  getDay,
  parse,
  setHours,
  setMinutes
} from 'date-fns';
import type { FormatOptions, Locale } from 'date-fns';

import LOCALES from 'constants/locales';

import { MAX_HOUR, MIN_HOUR } from '../config/calendarConfig';
import { CALENDAR_LOCALE_MAP } from './calendarLocaleMap';

/** ISO week: Monday is always the first day of the week (ignores locale default). */
export const startOfWeekMonday = (date: Date, options?: { locale?: Locale }) =>
  dateFnsStartOfWeek(date, { ...options, weekStartsOn: 1 });

export const localizer = dateFnsLocalizer({
  /** react-big-calendar passes `{ locale }` from `locales[culture]` — must forward for localized `p`/`P`/etc. */
  format: (
    date: Date,
    formatStr: string,
    options?: FormatOptions & { locale?: Locale }
  ) =>
    dateFnsFormat(date, formatStr, {
      ...options,
      locale:
        options?.locale ??
        CALENDAR_LOCALE_MAP[LOCALES.ENGLISH_US as keyof typeof CALENDAR_LOCALE_MAP]
    }),
  parse,
  startOfWeek: startOfWeekMonday,
  getDay,
  locales: CALENDAR_LOCALE_MAP
});

export const calendarMinDate = setMinutes(setHours(new Date(), MIN_HOUR), 0);
export const calendarMaxDate = setMinutes(setHours(new Date(), MAX_HOUR), 0);
